import { Alert, Box, Button, CircularProgress, Snackbar, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useGateMainContext } from "../GateMainContext";
import { GetSignupUserDataResponse, UsersGateApiClient } from "../Api/ApiServerHooks";
import { BrandingGateApiClient } from "../Api/BrandingGateApiClient";
import { useGateApi } from "../Api/useGateApi";
import { useTranslation } from 'react-i18next';

export default function Signup(props: any) {
    const { t } = useTranslation();
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [infoOpen, setInfoOpen] = useState(false);
    const [token, setToken] = useState<string>();
    const [localLogin, setLocalLogin] = useState<boolean | undefined>(undefined);
    const [userData, setUserData] = useState<GetSignupUserDataResponse>();
    const [accessTokenMS, setAccessTokenMS] = useState<string>();
    const { unauthorizedApi } = useGateApi(UsersGateApiClient);
    const { unauthorizedApi: brandingApi } = useGateApi(BrandingGateApiClient);
    const { setPreLoginBranding } = useGateMainContext();

    const [newPass, setNewPass] = useState<string>('');
    const [newPassCheck, setNewPassCheck] = useState<string>('');

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        let tok = queryParams.get('token');
        console.log('signupToken', tok);
        setToken(tok !== null ? tok : undefined);
    }, [location.search]);

    // Apply the inviting tenant's branding (passed as ?tenant=<slug> in the invite link) so the
    // signup page matches the branded login experience. Falls back to default branding otherwise.
    useEffect(() => {
        const tenantSlug = new URLSearchParams(location.search).get('tenant');
        if (!tenantSlug) return;
        let active = true;
        brandingApi.getBrandingBySlug(tenantSlug)
            .then((resolved) => { if (active) setPreLoginBranding(resolved); })
            .catch(() => { if (active) setPreLoginBranding(null); });
        return () => { active = false; };
    }, [location.search, brandingApi, setPreLoginBranding]);

    useEffect(() => {
        console.log(token, unauthorizedApi)
        if (token) {
            unauthorizedApi.getSignupUserData(token).then((res) => {
                if (res.msLogin === true) {
                    localStorage.setItem('ms-state', 'user-signup-microsoft');
                    localStorage.setItem('ms-signup-userid', res.userId!.toString());
                    localStorage.setItem('ms-signup-token', token);
                    if (res.localLogin !== true)
                        navigate('/auth-callback');
                    else setUserData(res);
                    /* instance.loginPopup(loginRequest).then((data) => {
                        setAccessTokenMS(data.accessToken);
                        setUserData(res);
                    })
                    .catch(e => {
                        console.log(e);
                    }); */
                }
                else setUserData(res);
            });
        }
        else setUserData(undefined);
    }, [token, unauthorizedApi]);

    function changePassword() {
        if (newPass.length !== 0 && newPassCheck.length !== 0 && newPass === newPassCheck && userData && userData.userId && token) {
            setButtonDisabled(true);
            unauthorizedApi?.setUserPassword(userData.userId, token, newPass).then((d) => {
                setButtonDisabled(false);
                if (d.ok === true)
                    navigate('/?email=' + d.email);
                else
                    setInfoOpen(true);
            });
        }
    }

    if (userData && !accessTokenMS)
        return (
            <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {userData.localLogin && userData.msLogin && localLogin === undefined && <Box>
                    <Box>
                        <Box sx={{}}>
                            <Button
                                //disabled={password === "" || userName === ""}
                                variant={'contained'}
                                size='large'
                                sx={{ width: '88%', height: '52px', marginBottom: '12px' }}
                                onClick={() => { setLocalLogin(true) }}>
                                <Typography sx={{ marginLeft: '12px', marginTop: '2px', fontWeight: 'bold' }}>{t('Users.LoginValidator')}</Typography>
                            </Button>
                            <Typography
                                sx={{ marginLeft: '12px', marginTop: '6px', marginBottom: '14px' }}
                                color='secondary'
                                fontSize={13}>{t('Users.OrUse')}</Typography>

                            <Box >
                                <Button variant='outlined' sx={{ width: '88%', height: '52px' }} onClick={() => {
                                    // localStorage.setItem('ms-state', 'user-signup-microsoft');
                                    navigate('/auth-callback');
                                    /* instance.loginPopup(loginRequest).then((data) => {
                                        setAccessTokenMS(data.accessToken);
                                    })
                                    .catch(e => {
                                        console.log(e);
                                    }); */
                                }}><Box sx={{ display: 'flex' }}>
                                        <img width={32} height={32} src={'/microsoft-logo.svg'} />
                                        <Typography sx={{ marginLeft: '12px', marginTop: '4px', fontWeight: 'bold' }}>{t('Users.MSLogin')}</Typography>
                                    </Box></Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>}
                {(localLogin === true || (userData.localLogin === true && userData.msLogin !== true)) && <Box>
                    <Box>
                        <Box>
                            <Box>
                                <TextField sx={{ margin: '12px', marginLeft: '24px', width: '350px' }} label={t('Users.PasswordNew')}
                                    type={"password"}
                                    size='small'
                                    name='new-pass'
                                    variant='outlined'
                                    value={newPass}
                                    onChange={(e) => { setNewPass(e.currentTarget.value); }} />
                            </Box>
                            <Box>
                                <TextField sx={{ margin: '12px', marginLeft: '24px', width: '350px' }} label={t('Users.PasswordNewAgain')}
                                    type={"password"}
                                    size='small'
                                    name='new-pass-check'
                                    variant='outlined'
                                    value={newPassCheck}
                                    onChange={(e) => { setNewPassCheck(e.currentTarget.value); }} />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                            <Button variant='contained' sx={{ margin: 'auto' }} onClick={changePassword}
                                disabled={newPass.length === 0 || newPassCheck.length === 0 || newPass !== newPassCheck || !userData || !userData.userId || !token || buttonDisabled}
                            >{t('Users.DoChangePassword')}</Button>
                        </Box>
                    </Box>
                </Box>}
            </Box>
        )
    else
        return <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress />

            <Snackbar open={infoOpen} autoHideDuration={3000} onClose={() => setInfoOpen(false)}>

                <Alert onClose={() => setInfoOpen(false)} severity="error" sx={{ width: '100%' }}>
                    {t('Users.RegistrationError')}
                </Alert>

            </Snackbar>
        </Box>
}
